// https://a11y-guidelines.orange.com/en/articles/make-a-screen-reader-talk/
const srSpeak = (text, priority = 'polite') => {
	const el = document.createElement('div');
	const id = `speak-${Date.now()}`;
	el.setAttribute('id', id);
	el.setAttribute('aria-live', priority);
	el.classList.add('visually-hidden');
	document.body.appendChild(el);

	window.setTimeout(() => {
		document.getElementById(id).innerHTML = text;
	}, 750);

	window.setTimeout(() => {
		document.body.removeChild(document.getElementById(id));
	}, 5000);
};

export default srSpeak;
